import { Link } from "react-router-dom";
import { categories } from "@/mocks/news";
import { getCategoryCount, getHotArticles } from "@/utils/news";

const hotList = getHotArticles(8);

export default function HotRanking() {
  return (
    <section
      aria-label="热榜与栏目速览"
      className="mx-auto grid max-w-[1400px] grid-cols-1 gap-6 px-4 md:px-6 lg:grid-cols-3"
    >
      <div className="rounded-lg border border-background-200 bg-background-100 p-6 lg:col-span-2">
        <div className="mb-5 flex items-center justify-between border-b border-background-200 pb-3">
          <h2 className="flex items-center gap-2 font-serif-cn text-xl font-bold text-foreground-950">
            <i className="ri-fire-fill text-primary-500" />
            实时热榜
          </h2>
          <span className="text-xs text-foreground-500">按站内热度排序 · 每 10 分钟更新</span>
        </div>
        <ol className="grid grid-cols-1 gap-x-8 md:grid-cols-2">
          {hotList.map((item, index) => (
            <li key={item.id} className="border-b border-background-200 py-3 last:border-0">
              <Link to={`/article/${item.id}`} className="group flex items-start gap-3">
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded font-serif-cn text-xs font-bold ${
                    index < 3
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-300 text-foreground-700"
                  }`}
                >
                  {index + 1}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="line-clamp-2 text-sm leading-snug text-foreground-800 transition group-hover:text-primary-600">
                    {item.title}
                  </span>
                  <span className="mt-2 block h-1 w-full overflow-hidden rounded-full bg-background-300">
                    <span
                      className="block h-full rounded-full bg-accent-400"
                      style={{ width: `${item.hot}%` }}
                    />
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>

      <aside className="rounded-lg border border-background-200 bg-background-50 p-6">
        <h2 className="mb-4 flex items-center gap-2 font-serif-cn text-xl font-bold text-foreground-950">
          <i className="ri-layout-grid-line text-primary-500" />
          栏目速览
        </h2>
        <ul className="space-y-2.5">
          {categories.map((item) => (
            <li key={item.slug}>
              <Link
                to={`/category/${item.slug}`}
                className="group flex items-center gap-3 rounded-md border border-background-200 px-3 py-2.5 transition hover:border-primary-300 hover:bg-primary-50"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${item.icon} text-lg`} />
                </span>
                <span className="flex-1">
                  <span className="block text-sm font-medium text-foreground-900 group-hover:text-primary-600">
                    {item.name}
                  </span>
                  <span className="block text-xs text-foreground-500">
                    共 {getCategoryCount(item.slug)} 篇内容
                  </span>
                </span>
                <i className="ri-arrow-right-s-line text-lg text-foreground-400 transition group-hover:text-primary-500" />
              </Link>
            </li>
          ))}
        </ul>
      </aside>
    </section>
  );
}